import { View } from 'react-native';
import { offsetX, offsetY, styles } from './DiscountScaleProgressMiniMilestone.styles';
import TextLato from '../../../text/text-lato/TextLato';
import { Icon } from '../../../icon/Icon';
import { ICON_NAMES } from '../../../icon/icon.helper';
import Animated, { SharedValue } from 'react-native-reanimated';
import { DiscountScale } from '@photosi/expo-photosi-sdk/build/Project';
import { useDiscountScaleProgressMiniMilestoneLogic } from './DiscountScaleProgressMiniMilestone.logic';
import Confetti from '../../confetti/Confetti';
import { Neutrals } from 'src/theme-v2/colors';

export const DiscountScaleProgressMiniMilestone = ({
  item,
  index,
  isMobile,
  steps,
  progressSV,
  anyMilestoneShowingCheckSV,
  lastReachedMilestone,
  showAnimationMilestone = false,
}: {
  item: DiscountScale;
  index: number;
  isMobile?: boolean;
  steps: number;
  progressSV: SharedValue<number>;
  anyMilestoneShowingCheckSV: SharedValue<boolean>;
  lastReachedMilestone?: number | null;
  showAnimationMilestone?: boolean;
}) => {
  const {
    left,
    milestoneAnimatedStyle,
    textAnimatedStyle,
    checkAnimatedStyle,
    confettiLayout,
    showConfetti,
    onLayout,
  } = useDiscountScaleProgressMiniMilestoneLogic(
    index,
    steps,
    progressSV,
    anyMilestoneShowingCheckSV,
    lastReachedMilestone,
  );

  return (
    index > 0 && (
      <View
        key={'Milestone' + index}
        style={[!isMobile ? styles.milestoneWrapper : styles.milestoneWrapperMobile, { left: `${left}%` }]}
        onLayout={onLayout}
      >
        {confettiLayout && showAnimationMilestone && (
          <Confetti
            count={250}
            width={confettiLayout.width}
            height={confettiLayout.height}
            milestoneReached={showConfetti}
            duration={1000}
            offsetY={offsetY}
            offsetX={offsetX}
          />
        )}
        <Animated.Text style={[styles.textNotActive, textAnimatedStyle]}>
          <TextLato style={styles.textPercentage}>-</TextLato>
          {item.discount}
          <TextLato style={styles.textPercentage}>%</TextLato>
        </Animated.Text>
        <Animated.View style={[styles.milestone, milestoneAnimatedStyle]}>
          <Animated.View style={[styles.checkIcon, checkAnimatedStyle]}>
            <Icon name={ICON_NAMES.Check} color={Neutrals.main.White} width={8} height={8} />
          </Animated.View>
        </Animated.View>
      </View>
    )
  );
};
